import {
	AccessRouteForm,
	AdditionalInfoForm,
	BasicInfoForm,
	CareerInformationForm,
	CorporationForm,
	ETCInfoForm,
	EducationForm,
	FCRegistrationForm,
	FamilyRelationshipForm,
	GStarClubForm,
	InsuranceExperienceForm,
	PersonalInfoForm,
	ProfessionalQualificationForm,
	TaxAccountantInfoForm,
	UpdateDateForm
} from "@/features/tax-accountant";
import { TaxAccountantResModel, useGetTaxAccountant } from "@/shared/api";
import { vars } from "@/shared/lib";
import { Button, Center, Column, Indicator, Row } from "@/shared/ui";
import { standardSchemaValidator, useForm } from "@tanstack/react-form";
import { createFileRoute, useNavigate, useParams, useRouter } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute("/(auth)/_layout/tax-accountant/$taxAccountantId/")({
	component: TaxAccountantDetail
});

function TaxAccountantDetail() {
	return (
		<Suspense
			fallback={
				<Center fullWidth style={{ minHeight: "100vh" }}>
					<Indicator />
				</Center>
			}
		>
			<TaxAccountantDetailForm />
		</Suspense>
	);
}

function TaxAccountantDetailForm() {
	const { taxAccountantId } = useParams({ from: "/(auth)/_layout/tax-accountant/$taxAccountantId/" });
	const { data } = useGetTaxAccountant({ taxAccountantId });
	const router = useRouter();
	const navigate = useNavigate();

	const form = useForm({
		defaultValues: data,
		asyncAlways: true,
		asyncDebounceMs: 700,
		validatorAdapter: standardSchemaValidator(),
		validators: { onChangeAsync: TaxAccountantResModel.model, onChangeAsyncDebounceMs: 700, onBlurAsyncDebounceMs: 700 }
	});

	return (
		<Column
			fullWidth
			style={{
				justifyContent: "flex-start",
				alignItems: "flex-start",
				gap: vars.size[48],
				paddingBottom: vars.size[48]
			}}
		>
			<Row
				fullWidth
				style={{
					justifyContent: "flex-start",
					gap: vars.size[8]
				}}
			>
				<Button color={"third"} size="small" onClick={() => router.history.back()}>
					{"뒤로가기"}
				</Button>


				<form.Subscribe
					selector={(state) => [state.values.basicInformation.registerStatus === "PENDING"]}
					children={([isRegisterPending]) =>
						<Button
							size="small"
							disabled={isRegisterPending}
							onClick={() => {
								navigate({
									to: "/tax-accountant/$taxAccountantId/modify",
									params: {
										taxAccountantId: taxAccountantId
									}
								});
							}}
						>
							{"수정하기"}
						</Button>
					}
				/>

			</Row>

			<Row
				fullWidth
				style={{
					justifyContent: "flex-start",
					alignItems: "flex-start",
					gap: vars.size[48]
				}}
			>
				<Column
					fullWidth
					style={{
						justifyContent: "flex-start",
						alignItems: "flex-start",
						gap: vars.size[32]
					}}
				>
					<BasicInfoForm viewType="VIEW" form={form} />
					<ProfessionalQualificationForm viewType="VIEW" form={form} />
					<CorporationForm viewType="VIEW" form={form} />
					<InsuranceExperienceForm viewType="VIEW" form={form} />
					<AccessRouteForm viewType="VIEW" form={form} />
					<FamilyRelationshipForm viewType="VIEW" form={form} />
					<GStarClubForm viewType="VIEW" form={form} />
				</Column>

				<Column
					fullWidth
					style={{
						justifyContent: "flex-start",
						alignItems: "flex-start",
						gap: vars.size[32]
					}}
				>
					<PersonalInfoForm viewType="VIEW" form={form} />
					<AdditionalInfoForm viewType="VIEW" form={form} />
					<ETCInfoForm viewType="VIEW" form={form} />
				</Column>

				<Column
					fullWidth
					style={{
						justifyContent: "flex-start",
						alignItems: "flex-start",
						gap: vars.size[32]
					}}
				>
					<UpdateDateForm viewType="VIEW" form={form} />
					<CareerInformationForm viewType="VIEW" form={form} />
					<EducationForm viewType="VIEW" form={form} />
					<TaxAccountantInfoForm viewType="VIEW" form={form} />
					<FCRegistrationForm viewType="VIEW" form={form} />
				</Column>
			</Row>
		</Column>
	);
}
